import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "hidden"]
  static values = { datasetKey: String, eventNamespace: String, numericOnly: Boolean }

  connect() {
    if (!this.hasHiddenTarget) return

    this.sync = this.sync.bind(this)
    this.sync()

    this.namespace = this.eventNamespaceValue || "selectSync"

    if (window.$ && this.hasSelectTarget) {
      this.$select = window.$(this.selectTarget)
      this.$select.on(
        `select2:select.${this.namespace} select2:unselect.${this.namespace} change.${this.namespace}`,
        this.sync
      )
    }

    this.element.addEventListener("submit", this.sync)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.sync)

    if (this.$select) {
      this.$select.off(`.${this.namespace}`)
      this.$select = null
    } else if (this.hasSelectTarget) {
      this.selectTarget.removeEventListener("change", this.sync)
    }
  }

  sync() {
    if (!this.hasSelectTarget) return

    const key = this.datasetKeyValue
    const ids = Array.from(this.selectTarget.selectedOptions)
      .map((opt) => (key ? (opt.dataset[key] || opt.value) : opt.value))

    this.writeIds(ids)
  }

  syncFromEvent(event) {
    this.writeIds((event.detail?.selectedOptions || []).map((option) => option.value))
  }

  writeIds(values) {
    let ids = values.filter(Boolean)

    if (this.numericOnlyValue) {
      ids = ids.filter((id) => !isNaN(Number(id)))
    }

    this.hiddenTarget.value = Array.from(new Set(ids)).join(",")
  }
}
